<template>
  <div>
       <div class="box-header title-boreder">
      
      <h3 class="box-title title"> Citas de Despacho  <h3 class="box-title title" style=""><span class="table-btn-icon"></span></h3> {{this.accountName}}</h3>
    </div>
    <div class="box box-success">
    <div class="box-header title-boreder">
      <h3 class="box-title box-title-sub"><img src="/static/img/icons/entregadas.png"> Cargar Citas </h3>
    </div>
      <div class="box-body">
        <div class="row">
          <div class="col-md-4">      
            <div class="form-group">  
              <label for="">Seleccione un archivo</label>
              <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" class="form-control"/>
              <div v-show="fileValidation !== ''" class="invalid-feedback">{{this.fileValidation}}</div>
            </div>
          </div>
          <div class="col-md-1 form-interspace">
            <div class="form-group" style="padding-top:25px;">
              <button v-on:click="handleUpload()" class="btn btn-sm btn-success" style="width: 70px">Cargar</button>
            </div>
          </div>
          <div class="col-md-1 form-interspace" v-if="this.uploadData !== null">
            <div class="form-group" style="padding-top:25px;">
              <button v-on:click="handleSubmit()" class="btn btn-sm btn-success" style="width: 70px">Registrar</button>
            </div>
          </div>
        </div>
        <div v-if="this.tableData" class="row">
          <div class="col-md-12">
            <div style="overflow:auto;">
                <vuetable
                  id="dispatchTable"
                  ref="vuetable"
                  :api-mode="false"
                  :fields="tableFields"
                  :data="tableData"
                  :css="tableCSS.table"
                >
                </vuetable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Vuetable from 'vuetable-2'
import moment from 'moment/moment.js'
import Modal from 'components/modal/Modal.vue'

export default {
  name: 'DispatchAppointmentsUpload',
  data () {
    return {
      loader: null,
      accountCode: '',
      accountName: '',
      fileValidation: '',
      file: null,
      uploadData: null,
      tableData: null,
      tableFields: [
        {
          name: 'accountCode',
          title: 'Cliente',
          callback: 'formatClient'
        },
        {
          name: 'clientOrder',
          title: 'Nro. de Orden'
        },
        {
          name: 'loadType',
          title: 'Tipo de Carga'
        },
        {
          name: 'plate',
          title: 'Placa'
        },
        {
          name: 'arrivalDate',
          title: 'Fecha de Llegada',
          callback: 'formatDate'
        },
        {
          name: 'arrivalTime',
          title: 'Hora de Llegada'
        },
        {
          name: 'appointmentDate',
          title: 'Fecha de Cita',
          callback: 'formatDate'
        },
        {
          name: 'appointmentTime',
          title: 'Hora de Cita'
        },
        {
          name: 'observations',
          title: 'Observaciones'
        }
      ],
      tableCSS: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger'
        }
      },
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      }
    }
  },
  created () {
    let code = this.$route.params.accountCode

    let found = this.userClients.find(function (item) {
      return item.code === code
    })

    if (found) {
      this.accountCode = found.code
      this.accountName = found.name
    }
  },
  components: {
    Vuetable,
    Modal
  },
  computed: {
    ...mapGetters([
      'userClients'
    ])
  },
  methods: {
    ...mapActions([
      'uploadDispatchApointmentFile',
      'saveDispatchApointmentFile'
    ]),
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    handleUpload () {
      document.activeElement.blur()

      if (this.validateFile()) {
        this.loader = this.$loading.show({
          loader: 'dots'
        })

        this.tableData = null
        this.uploadData = null

        let params = {
          accountCode: this.accountCode,
          file: this.file
        }

        this.uploadDispatchApointmentFile(params)
        .then((data) => {
          this.loader.hide()

          if (data.success) {
            this.tableData = data.data.items
            this.uploadData = data.data
          } else {
            this.$bus.$emit('modal-open', {
              title: 'Error',
              description: 'Ocurrió un error al subir o procesar el archivo.',
              type: 'danger',
              confirmText: 'Aceptar',
              cancelText: null,
              confirmBefore: () => {
              },
              confirmAfter: () => {
              },
              cancelBefore: () => {
              },
              cancelAfter: () => {
              }
            })
          }
        })
      }
    },
    handleSubmit () {
      document.activeElement.blur()

      if (this.uploadData !== null) {
        this.$bus.$emit('modal-open', {
          title: 'Confirmación',
          description: '¿Desea continuar con el registro de citas?',
          type: 'primary',
          confirmText: 'Aceptar',
          cancelText: 'Cancelar',
          confirmBefore: () => {
          },
          confirmAfter: () => {
            this.loader = this.$loading.show({
              loader: 'dots'
            })

            let params = {
              accountCode: this.accountCode,
              data: this.uploadData
            }

            this.saveDispatchApointmentFile(params)
            .then((data) => {
              let title, description, type
              if (data.success) {
                title = 'Éxito'
                description = 'Se grabó Citas de Despacho exitósamente.'
                type = 'success'
              } else {
                title = 'Error'
                description = 'Ocurrió un error al validar o grabar las citas.'
                type = 'danger'
              }

              this.loader.hide()

              this.$bus.$emit('modal-open', {
                title: title,
                description: description,
                type: type,
                confirmText: 'Aceptar',
                cancelText: null,
                confirmBefore: () => {
                },
                confirmAfter: () => {
                },
                cancelBefore: () => {
                },
                cancelAfter: () => {
                }
              })
            })
          },
          cancelBefore: () => {
          },
          cancelAfter: () => {
          }
        })
      }
    },
    formatClient (value) {
      return this.userClients.filter(item => item.code === value)[0].name
    },
    formatDate (value) {
      return moment(value).format('DD/MM/YYYY')
    },
    validateFile () {
      let result = false

      if (this.file === null) {
        this.fileValidation = 'Debe seleccionar un documento a subir'
      } else if (this.file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.fileValidation = 'La extensión del documento a subir debe ser MS Excel .xlsx'
      } else {
        this.fileValidation = ''
        result = true
      }

      return result
    }
  },
  destroyed () {
    if (this.loader !== null) {
      this.loader.hide()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// DispatchAppointmentsUpload.vue?9214ac7a